// Single source of truth for brand colors on the JS/TSX side (mirrors app_fe's
// AppColor.color.primaryBackground / primaryText in app_fe/src/Assets/Constants.tsx).
// index.css's :root carries the same values for CSS consumers — keep both in sync.
export const BRAND_INK = "#002F2F";
export const BRAND_ACCENT = "#E67E22";
export const BRAND_INK_HOVER = "#01514A";
export const BRAND_GRADIENT = `linear-gradient(135deg, ${BRAND_INK} 0%, #01524D 55%, #014A45 100%)`;
